<template>
	<DialogV2
		ref="dialog"
		width="500px"
		height="auto"
		:title="$t('text.exportingService')"
		:cancelLabel="isRunning ? null : $t('text.close')"
		:confirmLabel="isComplete ? $t('text.done') : null"
		:onCancel="handleClose"
		:onConfirm="handleClose"
		:showClose="!isRunning"
	>
		<template #content>
			<div class="export-progress-content">
				<ExportStatusWidget
					ref="statusWidget"
					:jobId="jobId"
					@complete="onJobComplete"
				/>

				<div class="export-info" v-if="isRunning">
					<v-icon color="info" size="20">mdi-information</v-icon>
					<span>{{ $t('text.exportProgressInfo') }}</span>
				</div>
			</div>
		</template>
	</DialogV2>
</template>

<script>
import DialogV2 from './DialogV2.vue'
import ExportStatusWidget from './ExportStatusWidget.vue'

export default {
	name: 'ExportProgressDialog',
	components: { DialogV2, ExportStatusWidget },
	props: {
		modelValue: Boolean,
		jobId: String,
	},
	emits: ['complete', 'update:modelValue'],

	data() {
		return {
			isComplete: false,
		}
	},

	watch: {
		modelValue: {
			immediate: true,
			handler(newVal) {
				if (newVal && this.$refs.dialog) {
					this.$refs.dialog.open()
				} else if (!newVal && this.$refs.dialog) {
					this.$refs.dialog.close()
				}
			}
		},
		jobId: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					this.isComplete = false
				}
			}
		}
	},

	computed: {
		isRunning() {
			return this.$refs.statusWidget?.isRunning ?? false
		}
	},

	methods: {
		handleClose() {
			this.$emit('update:modelValue', false)
			return true
		},

		onJobComplete(job) {
			this.isComplete = job.status === 'DONE'
			this.$emit('complete', job)
		}
	}
}
</script>

<style scoped>
.export-progress-content {
	padding: 16px;
	min-height: 200px;
}

.export-info {
	display: flex;
	align-items: flex-start;
	gap: 8px;
	margin-top: 16px;
	padding: 12px;
	background: #e3f2fd;
	border-radius: 4px;
	font-size: 13px;
	color: #1565c0;
}
</style>
